module.exports = __webpack_public_path__ + "static/CVS_pin_hover-aac6ee1f3d6dd6426b4177d90b1959e5.png";